var exports = {
  "Nr": "SubscriptionCard.module__card___Qkg0WT",
  "Vg": "SubscriptionCard.module__grid___Qkg0WT",
  "Qs": "SubscriptionCard.module__content___Qkg0WT",
  "wx": "SubscriptionCard.module__header___Qkg0WT",
  "DD": "SubscriptionCard.module__title___Qkg0WT",
  "h_": "SubscriptionCard.module__description___Qkg0WT",
  "h9": "SubscriptionCard.module__renewalInfo___Qkg0WT",
  "w$": "SubscriptionCard.module__pendingChangeInfo___Qkg0WT",
  "o1": "SubscriptionCard.module__actions___Qkg0WT",
  "hP": "SubscriptionCard.module__actionButton___Qkg0WT",
  "H2": "SubscriptionCard.module__legacyRateBadge___Qkg0WT",
};

module.exports = exports;
